import { render, staticRenderFns } from "./AppGithubCorner.vue?vue&type=template&id=d5a0063e&scoped=true&"
import script from "./AppGithubCorner.vue?vue&type=script&lang=js&"
export * from "./AppGithubCorner.vue?vue&type=script&lang=js&"
import style0 from "./AppGithubCorner.vue?vue&type=style&index=0&id=d5a0063e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a0063e",
  null
  
)

export default component.exports